import { Component } from '@angular/core';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  version: string = environment.version;
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/about/about.component.ts